import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  setMessageFilterKey,
  setMessageFilterKeyword,
  setEventFilterKeyword,
  setFilteredMessages,
  setLoadingFilteredMessages,
  setShowFilterSearch
} from '../../actions/application';
import { getFilterMessage } from '../../services/message';
import { getCredentials } from '../../selectors/application';
import './top-bar-message-list.scss';
import FilterIcon from '../../assets/icons/header/filter.svg?react';
import SearchIcon from '../../assets/icons/search-grey.svg?react';
import CloseIcon from '../../../public/assets/images/close-icon-grey.svg?react';

const SearchEmailOld = props => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  const [setTypeSearch, setSetTypeSearch] = useState('body');

  const resetSearch = () => {
    props.setMessageFilter('ALL');
    props.setMessageFilterKeyword(null);
    setSearchTerm('');
    props.setFilteredMessages([]);
  };

  useEffect(() => {
    props.setShowFilterSearch(false);
    setSetTypeSearch('body');
    if (props.application.messageFilterKey === 'USER_SEARCH' && props.application.messageFilterKeyword) {
      setSearchTerm(props.application.messageFilterKeyword);
    }
    // eslint-disable-next-line
  }, []);


  const handleRequestSearch = async () => {
    try {
      if (searchTerm !== null && searchTerm !== '') {
        if (
          !props.login.formValues.smtpHost.includes('smtp.ionos.es')
        ) {
          props.setLoadingFilteredMessages();
          const filteredMessages = await getFilterMessage(
            props.credentials,
            props.application.selectedFolderId,
            searchTerm,
            setTypeSearch
          );
          props.setFilteredMessages(filteredMessages);
        }
        props.setMessageFilter('USER_SEARCH');
        props.setMessageFilterKeyword(searchTerm);
      } else {
        props.setMessageFilter('ALL');
        props.setFilteredMessages([]);
      }
    } catch (error) {
      console.error(error);
      console.error(
        'El servidor de correo está tardando en responder. Pruebe con otro filtro.'
      );
      resetSearch();
    }
  };

  const { showFilterSearch } = props;

  return (
    <>
      <div className="top-search-bar-container">
        <input
          type="search"
          placeholder={t('topBar.search')}
          value={searchTerm}
          onChange={event => setSearchTerm(event.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              handleRequestSearch();
            }
          }}
          className="top-search-bar-input"
        />
        <div className="top-divider-icon-container">
          <div className="top-search-bar-divider" />
          {searchTerm ? (
            <>
              <SearchIcon
                className="top-search-icon"
                onClick={handleRequestSearch}
              />
              <CloseIcon
                className="top-search-icon"
                onClick={resetSearch}
                style={{ cursor: 'pointer' }}
              />
            </>
          ) : (
            <SearchIcon
              className="top-search-icon"
              onClick={handleRequestSearch}
            />
          )}
        </div>
      </div>

      <FilterIcon
        className={`lf-icon lf-icon-filter-1 lf-icon-filter-1`}
        onClick={() => {
          props.setShowFilterSearch(!showFilterSearch);
        }}
        id="filter-search-bar"
      />
    </>
  );
};

const mapStateToProps = state => ({
  eventFilterKeyword: state.application.eventFilterKeyword,
  showFilterSearch: state.application.showFilterSearch,
  application: state.application,
  credentials: getCredentials(state),
  login: state.login
});

const mapDispatchToProps = dispatch => ({
  setMessageFilter: messageFilter =>
    dispatch(setMessageFilterKey(messageFilter)),
  setMessageFilterKeyword: keyword =>
    dispatch(setMessageFilterKeyword(keyword)),
  setEventFilterKeyword: eventFilterKeyword =>
    dispatch(setEventFilterKeyword(eventFilterKeyword)),
  setShowFilterSearch: showFilterSearch =>
    dispatch(setShowFilterSearch(showFilterSearch)),
  setFilteredMessages: messages => dispatch(setFilteredMessages(messages)),
  setLoadingFilteredMessages: () => dispatch(setLoadingFilteredMessages())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchEmailOld);
